import React, { useEffect, useState, useContext } from 'react'

import LoadingContext from '../../context/Loading/Loading'
import UserContext from '../../context/User/User'
import AuthService from '../../utilities/services/auth.service'

import { ORGANIZATION_PERMISSION_SLUGS } from '@blocktickets/shared-utils'
import { checkPermission, getDefaultSeason } from '../../utilities/helpers'

import { getSeasons } from '../../utilities/api'

import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Card from 'react-bootstrap/Card'

import { SeasonSelector } from '../SeasonSelector'
import { PackagesList } from './PackagesList'
import { HoldersList } from './HoldersList'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { NoPermissionsContainer } from '../NoPermissionsContainer'
import { EmptyContainer } from '../EmptyContainer'

export default function SeasonPackagesWrapper({ organization }) {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)
  const { orgPermissions } = useContext(UserContext)
  const { getPermissions } = AuthService

  const orgPermissionsReady = orgPermissions?.length > 0
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(
      getPermissions(),
      ORGANIZATION_PERMISSION_SLUGS.VIEW_SEASON_PACKAGES
    )

  const [key, setKey] = useState('season-packages')

  const [seasons, setSeasons] = useState()

  const [season, setSeasonSelected] = useState('')

  const loadSeasons = () => {
    getSeasons(organization.uuid)
      .then((res) => {
        setSeasons(res.data)
        // select the current season - start and end time is in between current time
        const selected = getDefaultSeason(res.data)

        if (selected) setSeasonSelected(selected?.id)
      })
      .catch((err) => console.error(err))
      .finally(() => hideLoading())
  }

  useEffect(() => {
    if (!orgPermissionsReady) return
    if (!hasPermission) {
      hideLoading()
      return
    }

    showLoading()
    loadSeasons()
  }, [orgPermissionsReady, hasPermission, organization?.uuid])

  if (!orgPermissionsReady) {
    return <PageLoadingContainer style="without-sidebar" />
  }

  if (!hasPermission) {
    return (
      <div className="spacer-sm">
        <NoPermissionsContainer style="without-sidebar" />
      </div>
    )
  }

  if (isLoading) {
    return <PageLoadingContainer style="without-sidebar" />
  }

  return (
    <section
      className="spacer-sm"
      data-testid="season-packages-wrapper-content"
    >
      <div className="mb-4">
        <SeasonSelector
          seasons={seasons}
          selected={season}
          setSelected={setSeasonSelected}
        />
      </div>
      {season ? (
        <Tabs
          defaultActiveKey="season-packages"
          variant="pills"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="nav-pills-default w-max-content"
        >
          <Tab eventKey="season-packages" title="Season Packages">
            {key === 'season-packages' && <PackagesList seasonId={season} />}
          </Tab>
          <Tab eventKey="package-holders" title="Package Holders">
            {key === 'package-holders' && (
              <HoldersList
                seasonId={season}
                organizationName={organization?.name}
                seasonName={
                  seasons?.find((s) => Number(s.id) === Number(season))?.name
                }
              />
            )}
          </Tab>
        </Tabs>
      ) : (
        <Card body>
          <EmptyContainer style="center lg">
            <p>Select a season to view its packages</p>
          </EmptyContainer>
        </Card>
      )}
    </section>
  )
}
